import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import {
    AuditChannel,
    AuditLogChangeType,
    HistoryItem,
    Resource,
    ResourceType,
} from "@common/types/auditLog";
import { WorkspaceMember } from "@common/types/workspace";
import { DateCell } from "./cells/DateCell";
import { UpdatedByCell } from "./cells/UpdatedByCell";
import { ActivityCell } from "./cells/ActivityCell";
import { EntityCell } from "./cells/EntityCell";
import { ActionsCell } from "./cells/ActionsCell";
import { HistoryColumn } from "./historyView";

export interface HistoryRow {
    id: string;
    date: Date;
    actorId: number | null;
    actorName: string | null;
    actorType: string;
    sourceType: string;
    resourceType: ResourceType;
    changeTypes: AuditLogChangeType[];
    fields: string[];
    count: number;
    resourceIds: string[];
    resources?: Resource[];
    entityIds: number[];
    member?: WorkspaceMember;
    historyItem: HistoryItem;
    revertedAt?: Date;
    system?: string | null;
    channel: AuditChannel | null;
}

export const REVERT_TOAST_ID = "audit-log-revert";

export function getShowRevertedParam(
    historyRow: HistoryRow | null,
): true | undefined {
    return historyRow?.revertedAt ? true : undefined;
}

export const historyViewConfig: ViewConfig<HistoryRow, HistoryColumn, never> = {
    columns: {
        [HistoryColumn.DATE]: {
            name: "Date",
            header: "",
            accessorKey: "date",
            cell: DateCell,
            ...DATE_COLUMN_SIZE,
        },
        [HistoryColumn.UPDATED_BY]: {
            name: "Updated by",
            header: "Updated by",
            accessorKey: "actorId",
            cell: UpdatedByCell,
            minSize: 150,
            maxSize: 200,
        },
        [HistoryColumn.ACTION]: {
            name: "Activity",
            header: "Activity",
            accessorKey: "sourceType",
            cell: ActivityCell,
            minSize: 300,
            maxSize: 800,
        },
        [HistoryColumn.ENTITY]: {
            name: "Entity",
            header: "Entity",
            accessorKey: "entityIds",
            cell: EntityCell,
            minSize: 100,
            maxSize: 100,
        },
        [HistoryColumn.ACTIONS]: {
            name: "",
            header: "",
            accessorKey: "id",
            cell: ActionsCell,
            minSize: 220,
            maxSize: 260,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
